import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';

const FashionEvents = () => {
  const fashionService = services[1];

  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="font-display text-5xl md:text-6xl font-bold text-red-500 mb-6 uppercase">
            Fashion Shoot & Event Hire
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            {fashionService.description}
          </p>
        </div>

        {/* Hero Image */}
        <div className="max-w-6xl mx-auto mb-20">
          <img 
            src="https://images.unsplash.com/photo-1595065666634-4725aa7e8379" 
            alt="Fashion editorial photography"
            className="w-full h-96 object-cover rounded-lg"
          />
        </div>

        {/* Features */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Perfect For</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {fashionService.features.map((feature, index) => (
              <div key={index} className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                  <Check className="text-red-500" size={20} />
                </div>
                <h3 className="text-lg font-semibold text-white">{feature}</h3>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Why Choose EWS</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Controlled Access & Discretion</h3>
              <p className="text-gray-400 leading-relaxed">
                Private, secure environment with professional access control. Your creative vision remains confidential.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Strong Visual Identity</h3>
              <p className="text-gray-400 leading-relaxed">
                Dark, atmospheric spaces designed for striking imagery that stands out in editorials and campaigns.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Flexibility for Creative Teams</h3>
              <p className="text-gray-400 leading-relaxed">
                Adaptable environments that work with your vision. Bring your stylists, designers, and creative team.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Aesthetic Environments</h3>
              <p className="text-gray-400 leading-relaxed">
                Carefully curated spaces with cinematic lighting and noir-inspired design perfect for editorial work.
              </p>
            </div>
          </div>
        </div>

        {/* Pricing */}
        <div className="max-w-4xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Pricing Packages</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {fashionService.pricing.map((pkg, index) => (
              <div 
                key={index} 
                className="bg-zinc-900 rounded-lg p-8 border border-red-900/20 hover:border-red-600/50 transition-all text-center"
              >
                <h3 className="text-xl font-semibold text-white mb-2">{pkg.package}</h3>
                <p className="text-4xl font-bold text-red-500 my-6">{pkg.price}</p>
                <Link 
                  to="/contact"
                  className="block w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-full font-mono text-sm tracking-widest uppercase transition-all"
                >
                  Enquire
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* Gallery */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Fashion & Boudoir Gallery</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <img 
              src="https://images.unsplash.com/photo-1515886657613-9f3515b0c78f" 
              alt="Fashion boudoir styling"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://images.unsplash.com/photo-1509631179647-0177331693ae" 
              alt="Sensual fashion photography"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://images.unsplash.com/photo-1524638431109-93d95c968f03" 
              alt="Artistic intimate portrait"
              className="w-full h-80 object-cover rounded-lg"
            />
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <h2 className="text-3xl font-semibold text-white mb-4">Book Your Fashion Shoot</h2>
          <p className="text-gray-400 mb-8">Let's create something extraordinary together</p>
          <Link 
            to="/contact"
            className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-mono text-sm tracking-widest uppercase transition-all"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FashionEvents;